export function usePermissoes(claims = {}) {
  const isAdmin = claims.admin === true;
  const isColaborador = claims.colaborador === true;
  const isQualidade = claims.qualidade === true;
  const isDP = claims.dp === true;

  const isVisitante =
    !isAdmin && !isColaborador && !isQualidade && !isDP;

  return {
    // PERFIS
    isAdmin,
    isColaborador,
    isQualidade,
    isDP,
    isVisitante,

    // SGQ
    podeVerSGQ: isAdmin || isQualidade || isColaborador,
    podeCriarSGQ: isAdmin || isQualidade,
    podeEditarSGQ: isAdmin || isQualidade,
    podeExcluirSGQ: isAdmin || isQualidade,
    podeVerOcorrencias: isAdmin || isQualidade,

    // DEPARTAMENTO PESSOAL
    podeVerDP: isAdmin || isDP,
    podeCriarDP: isAdmin || isDP,
    podeEditarDP: isAdmin || isDP,
    podeExcluirDP: isAdmin,

    // KPIs (exemplo)
    podeVerKPI: !isVisitante,
    podeEditarKPI: isAdmin || isQualidade,
  };
}
